<div class="flex flex-col gap-6">
  <p class="m-0 inline-flex w-fit items-center rounded-full bg-emerald-50 px-3 py-1.5 text-sm font-bold text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-200">
    Account created · 14-day trial started
  </p>
  <div class="flex flex-col gap-3">
    <h1 class="use-grotesque m-0 text-4xl font-bold leading-none tracking-tight text-balance sm:text-5xl">
      How do you want to <span class="text-primary">start?</span>
    </h1>
    <p class="m-0 text-xl font-semibold leading-snug text-muted-foreground">Choose the route that fits your available time.</p>
  </div>

  <div class="flex flex-col gap-3">
    <button type="button" class="rounded-xl border-2 border-primary bg-card p-4 text-left hover:bg-primary/5" (click)="quickBrief()">
      <span class="inline-flex rounded-full bg-primary/10 px-3 py-1 text-sm font-bold text-accent">~3–5 min</span>
      <span class="mt-2 block text-xl font-bold">Quick Brief</span>
      <span class="mt-1 block text-base font-medium text-muted-foreground">We'll generate everything with AI. You'll be posting briefs in a few minutes.</span>
      <span class="mt-3 block text-lg font-bold text-primary">Get started fast →</span>
    </button>
    <button type="button" class="rounded-xl border border-border bg-card p-4 text-left hover:border-primary hover:bg-primary/5" (click)="skip()">
      <span class="inline-flex rounded-full bg-muted px-3 py-1 text-sm font-bold text-foreground">Instant</span>
      <span class="mt-2 block text-xl font-bold">Skip Brief Creation</span>
      <span class="mt-1 block text-base font-medium text-muted-foreground">Jump straight into the platform and explore all features. Create briefs later when you're ready.</span>
      <span class="mt-3 block text-lg font-bold text-foreground">Explore now →</span>
    </button>
  </div>

  <fieldset class="m-0 border-0 p-0">
    <legend class="text-base font-bold">
      What's your main goal? <span class="font-semibold text-muted-foreground">Optional</span>
    </legend>
    <div class="mt-2 flex flex-wrap gap-2">
      @for (goal of goals; track goal) {
        <button
          type="button"
          class="h-10 rounded-full px-3.5 text-base font-bold"
          [class]="selected(goal) ? 'bg-primary text-primary-foreground' : 'border border-border bg-card text-foreground'"
          [attr.aria-pressed]="selected(goal)"
          (click)="toggle(goal)">
          {{ goal }}
        </button>
      }
    </div>
  </fieldset>
  <p class="m-0 text-base font-semibold text-muted-foreground">Don't worry, you can always edit everything later.</p>
</div>
